
export const config = {
    PRODUCTION: process.env.REACT_APP_NODE_ENV === 'PROD' ? true : false,
    PLATFORM: process.env.REACT_APP_PLATFORM,
    ORIGIN: process.env.REACT_APP_ORIGIN,
    ENDPOINT: process.env.REACT_APP_ENDPOINT,

    AI_API_ENDPOINT: process.env.REACT_APP_AI_API_ENDPOINT,

    THAID_APP_ID: process.env.REACT_APP_THAID_APP_ID,
    THAID_APP_SECRET: process.env.REACT_APP_THAID_APP_SECRET,
    THAID_APP_PLATFORM: process.env.REACT_APP_THAID_APP_PLATFORM,
}